import {
  ACCESS_TOKEN_EXPIRED_MESSAGE,
  INVALID_ACCESS_TOKEN_MESSAGE,
} from '../../constants/errors';

export const isTokenExpired = (
  data: { fault?: { faultstring: string } },
) => data.fault?.faultstring === INVALID_ACCESS_TOKEN_MESSAGE
  || data.fault?.faultstring === ACCESS_TOKEN_EXPIRED_MESSAGE;